var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFire(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.044,5.529c-1.098-1.426-2.233-2.9-3.036-4.495C14.669,.359,13.995-.048,13.256-.008c-.713,.041-1.314,.496-1.569,1.188-.342,.933-.687,2.638-.687,4.345,0,2.209,.688,3.701,1.24,4.901,.469,1.017,.839,1.82,.746,2.847-.09,.979-.946,1.735-2.027,1.727-2.585-.029-3.243-3.303-3.338-6.043-.032-.897-.637-1.655-1.505-1.885-.868-.229-1.77,.132-2.241,.896-1.208,1.961-1.874,4.103-1.874,6.031,0,5.514,4.523,10,10.006,10,5.511-.033,9.994-4.52,9.994-9.983,.056-3.276-1.983-5.925-3.956-8.487Zm-6.05,16.471c-4.38,0-7.994-3.589-7.994-8,0-1.54,.575-3.356,1.622-4.973,.179,5.104,2.066,7.936,5.315,7.973h.047c2.061,0,3.811-1.548,3.994-3.544,.142-1.56-.398-2.732-.921-3.866-.52-1.128-1.057-2.294-1.057-4.064,0-1.153,.196-2.384,.423-3.206,.863,1.606,1.967,3.04,3.037,4.431,1.843,2.395,3.584,4.656,3.541,7.25,0,4.385-3.591,7.974-8.006,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFire);
export default __webpack_public_path__ + "static/media/fire.f5c657e0819722fd837e8276f6a30254.svg";
export { ForwardRef as ReactComponent };